import React from 'react';
import { Chip, Box, Typography } from '@mui/material';
import { PRODUCT_CATEGORIES } from '../constants/categories';
import type { ProductCategory } from '../constants/categories';

interface CategoryFilterProps {
  selectedCategory: ProductCategory | '';
  onSelectCategory: (category: ProductCategory | '') => void;
  showHeading?: boolean;
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  selectedCategory,
  onSelectCategory,
  showHeading = true,
}) => {
  return (
    <Box className={showHeading ? undefined : 'bottomheader'} sx={{ mb: showHeading ? 4 : 0, p: 0 }}>
      {showHeading && (
        <Typography variant="h6" gutterBottom>
          Categories
        </Typography>
      )}
      <Box className="cat-container" sx={{ display: 'inline-flex', gap: 0 }}>
        <Chip
          className="category-chip"
          label="All"
          onClick={() => onSelectCategory('')}
          color={selectedCategory === '' ? 'primary' : 'default'}
          variant={selectedCategory === '' ? 'filled' : 'outlined'}
          sx={{ mb: 1 }}
        />
        {PRODUCT_CATEGORIES.map((category) => (
          <Chip
            className="category"
            key={category}
            label={category}
            onClick={() => onSelectCategory(category)}
            color={selectedCategory === category ? 'primary' : 'default'}
            variant={selectedCategory === category ? 'filled' : 'outlined'}
            sx={{ mb: 1 }}
          />
        ))}
      </Box>
    </Box>
  );
};
